import { FolderOpen, House, Library, Settings } from 'lucide-react';
import type { ReactNode } from 'react';
import { NavLink, Outlet } from 'react-router';
import { BrandWordmark } from '@/components/brand/BrandWordmark';
import { UpdateBanner } from '@/features/offline/components/UpdateBanner';
import styles from './AppShell.module.css';

const NAV: ReadonlyArray<{ to: string; label: string; end: boolean; icon: ReactNode }> = [
  { to: '/', label: 'Start', end: true, icon: <House aria-hidden="true" /> },
  { to: '/library', label: 'Library', end: false, icon: <Library aria-hidden="true" /> },
  { to: '/projects', label: 'Projects', end: false, icon: <FolderOpen aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', end: false, icon: <Settings aria-hidden="true" /> },
];

/**
 * Branded shell for non-studio pages (the studio has its own compact header). On phones
 * the same navigation becomes a bottom tab bar within reach of a thumb.
 */
export function AppShell() {
  return (
    <div className={styles.shell}>
      <a className={styles.skip} href="#main">
        Skip to content
      </a>
      <header className={styles.header}>
        <NavLink to="/" className={styles.brand ?? ''} aria-label="Jamie’s Nails Pro — start page">
          <BrandWordmark variant="compact" />
        </NavLink>
        <nav aria-label="Main" className={styles.nav}>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
            >
              <span className={styles.icon}>{item.icon}</span>
              <span className={styles.label}>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </header>
      <UpdateBanner />
      <main id="main" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
